module.exports = __webpack_public_path__ + "img/Virtual_Fashion.a67b5619.png";